import { Pipe, PipeTransform } from '@angular/core';
import { Currency, format } from '../currency';

/**
 * Transforms a price into a formatted string with the given currency.
 * e.g. {{ price | currency: 'eur' }}
 */

@Pipe({
  name: 'price',
  standalone: true,
})
export class CurrencyPipe implements PipeTransform {
  transform(price: number | undefined, currency: Currency | undefined): string {
    return format(price, currency);
  }
}
